import { Row, SheetData } from 'read-excel-file/browser';

// Excel counts days since 30/12/1899 while javascript counts milliseconds since 01/01/1970.
const DAYS_BEFORE_UNIX_EPOCH = 25569;
const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000;

class ExcelHelper {
    // Turns a sheet of cells into one object per row, using the first row as the column names.
    static toRowObjects(sheet: SheetData): Record<string, any>[] {
        // An empty row is kept wherever it sits in the sheet, so an empty row above the header row
        // would be read as the column names. Dropping them up front covers that and the empty rows
        // in between the data alike.
        const [columnNames, ...rows] = sheet.filter(row => ExcelHelper.hasContent(row));
        if (!columnNames) {
            return [];
        }

        return rows.map(row => ExcelHelper.toRowObject(columnNames, row));
    }

    private static hasContent(row: Row): boolean {
        return row.some(cell => cell !== null && cell !== undefined);
    }

    private static toRowObject(columnNames: Row, row: Row): Record<string, any> {
        const object: Record<string, any> = {};

        columnNames.forEach((columnName, index) => {
            const value = row[index];
            // An empty cell reads as null. Leaving the property out altogether keeps the row
            // indistinguishable from one where the column itself is absent, which is what the
            // callers check for.
            if (columnName === null || columnName === undefined || value === null || value === undefined) {
                return;
            }

            object[String(columnName)] = value instanceof Date ? ExcelHelper.toSerialNumber(value) : value;
        });

        return object;
    }

    // A date formatted cell holds a number just like any other numeric cell; only its formatting
    // makes it a date. The callers want that number, so hand back what the cell actually holds.
    private static toSerialNumber(date: Date): number {
        return date.getTime() / MILLISECONDS_PER_DAY + DAYS_BEFORE_UNIX_EPOCH;
    }
}

export default ExcelHelper;
